import { render, staticRenderFns } from "./FileViewerArticle.vue?vue&type=template&id=e6cfcfe2&scoped=true&"
import script from "./FileViewerArticle.vue?vue&type=script&lang=js&"
export * from "./FileViewerArticle.vue?vue&type=script&lang=js&"
import style0 from "./FileViewerArticle.vue?vue&type=style&index=0&id=e6cfcfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cfcfe2",
  null
  
)

export default component.exports